import { render, staticRenderFns } from "./VerifyPhone.vue?vue&type=template&id=26306562&scoped=true&"
import script from "./VerifyPhone.vue?vue&type=script&lang=ts&"
export * from "./VerifyPhone.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyPhone.vue?vue&type=style&index=0&id=26306562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26306562",
  null
  
)

export default component.exports